import React, {useState} from 'react';
import styled from "styled-components";
import Paper from "@mui/material/Paper";
import {colors} from "../../maps/colors";
import {hasRTLCharacters} from "../../utils";
import TextField from "@mui/material/TextField";
import {useDebounce} from "react-use";

const WrapperProductsStyled = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, 200px);
    gap: 25px;
    margin-top: 20px;
`;

const WrapperStyled = styled.div`
    margin-bottom: 10px;
`;

const ItemStyled = styled.div`
    cursor: pointer;
`;

const ItemImageStyled = styled.div`
    width: 100%;
    height: 200px;

    img {
        width: 100%;
        height: 200px;
        object-fit: cover;
    }
`;

const ItemInfoStyled = styled.div`
    padding: 10px;

    .product-info-label {
        color: ${colors.LIGHT_GRAY};
        font-size: 11px;
        margin-right: 3px;
    }

    //.name{
    //    display: inline-block;
    //}

    .pika-name {
        display: inline-block;
        font-size: 14px;
        padding: 0 6px 13px;
        margin: 0;
        direction: ltr;
        text-align: left;
        width: 144px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: text-top;
    }

    &.rtl {
        direction: rtl;
        text-align: right;
    }
`;

const ProductsShow = ({items, selectProductIndex, searchFor}) => {
    const [searchValue, s_searchValue] = useState("");

    const [, cancel] = useDebounce(
        () => {
            searchFor(searchValue);
        },
        1200,
        [searchValue]
    );

    return (
        <WrapperStyled>
            <TextField
                autoComplete={"off"}
                sx={{width: '250px'}}
                value={searchValue}
                onChange={(e) => {
                    s_searchValue(e.target.value);
                }}
                id="outlined-basic" label="Search" variant="outlined" size="small"/>
            <WrapperProductsStyled>


                {items.map((item, index) => {
                    const onShelf = item?.placementCount || 0;
                    const onSite = item?.inventory?.[0]?.quantity || 0;
                    const total = onShelf + onSite;

                    return (
                        <ItemStyled key={item._id + index}
                                    onClick={() => selectProductIndex(index)}
                        >
                            <Paper elevation={3}>
                                <ItemImageStyled>
                                    <img src={item.imageUrl} alt=""/>
                                </ItemImageStyled>
                                <ItemInfoStyled>
                                    <div>
                                        <span className="product-info-label">Name</span>
                                        <span
                                            className={hasRTLCharacters(item.name) ? "rtl pika-name" : "ltr pika-name"}>{item.name}</span>
                                    </div>
                                    <div>
                                        <span className="product-info-label">SKU</span>
                                        <span>{item.sku}</span>
                                    </div>
                                    <div>
                                        <span className="product-info-label">Barcode</span>
                                        <span>{item.barcode}</span>
                                    </div>
                                    <div>
                                        <span className="product-info-label">On shelves</span>
                                        <span>{onShelf}</span>
                                    </div>
                                    <div>
                                        <span className="product-info-label">On Site</span>
                                        <span>{onSite}</span>
                                    </div>
                                    <div>
                                        <span className="product-info-label">Total</span>
                                        <span>{total}</span>
                                    </div>
                                </ItemInfoStyled>
                            </Paper>
                        </ItemStyled>
                    );
                })}
            </WrapperProductsStyled>
        </WrapperStyled>
    );
};

export default ProductsShow;